module.exports = "./img/1b27c886a9457cdb6388d4b14b44c736.jpg";